/**
 * User: ronald
 * Date: 1/7/13
 * Time: 7:10 PM
 */
"use strict";

const qs = require('qs');
const SoaModel = require('bunsen/models/SoaModel');
const Offer = SoaModel.extend({}, {
    DisplayOfferStatus: {
        expired: 'expired',
        canceledNoLongerInterested: 'canceledNoLongerInterested',
        canceledPassed: 'canceledPassed',
        canceledOther: 'canceledOther',
        dealerCountered: 'dealerCountered',
        buyerCountered: 'buyerCountered',
        newBuyerOfferWithoutReserve: 'newBuyerOfferWithoutReserve',
        newBuyerOfferWithReserve: 'newBuyerOfferWithReserve',
        newDealerOffer: 'newDealerOffer',
        dealerAccepted: 'dealerAccepted',
        newOrder: 'newOrder',
        newOrderManualReview: 'newOrderManualReview',
        requestedOffer: 'requestedOffer'
    },
    STATUS_AMENDED: 'AMENDED',
    STATUS_SUBMITTED: 'SUBMITTED',
    STATUS_ACCEPTED: 'ACCEPTED',
    STATUS_COUNTERED: 'COUNTERED',
    STATUS_EXPIRED: 'EXPIRED',
    STATUS_NEW: 'NEW',
    STATUS_CANCELED: 'CANCELED',
    STATUS_REQUESTED: 'REQUESTED'
});
const root = typeof window === 'undefined' ? global : window;
root.bunsen = root.bunsen || {};

// Attaching to bunsen until bOMT and checkout are commonJS
module.exports = root.bunsen.Offer = Offer;

const SoaCollection = require('bunsen/collections/SoaCollection');
const endpoints = require('dibs-endpoints');
const AdjustmentList = require('bunsen/models/ecomm/AdjustmentList');
const Transaction = require('bunsen/models/ecomm/Transaction');
const Notes = require('bunsen/collections/Notes');
const Note = require('bunsen/models/Note');
const Party = require('bunsen/models/Party');
const Anchor = require('bunsen/models/Anchor');
const PaymentAuthorization = require('bunsen/models/ecomm/PaymentAuthorization');
const Backbone = require('dibs-backbone');
const transitionMixin = require('bunsen/models/mixins/ecomm/transitionMixin');
const financialAmountMixin = require('bunsen/models/mixins/financialAmountMixin');
const Clump = require('bunsen/libraries/clump');
const Period = require('bunsen/models/Period');
const $ = require('dibs-jquery-shim');
const _ = require('underscore');
const FinancialAmount = require('bunsen/models/FinancialAmount');
const Action = require('bunsen/models/ecomm/Action');
const uri = require('bunsen/helpers/uri');

_.extend(Offer.prototype, {
    offerDisplayStatus(options) {
        options = _.defaults({}, options, {
            transaction: this.get('transaction')
        });
        const { transaction } = options;

        if (transaction.isCanceled()) {
            switch (transaction.get('cancellationReason')) {
                case Transaction.CANCELLATION_REASON_BUYER_NO_LONGER_INTERESTED_PRE_CHECKOUT:
                    return Offer.DisplayOfferStatus.canceledNoLongerInterested;
                case Transaction.CANCELLATION_REASON_BUYER_PASSED_ON_OFFER_PRE_CHECKOUT:
                    return Offer.DisplayOfferStatus.canceledPassed;
                case Transaction.CANCELLATION_REASON_OFFER_EXPIRED_PRE_CHECKOUT_DEALER_INACTION:
                case Transaction.CANCELLATION_REASON_OFFER_EXPIRED_PRE_CHECKOUT_BUYER_INACTION:
                    return Offer.DisplayOfferStatus.expired;
                default:
                    return Offer.DisplayOfferStatus.canceledOther;
            }
        }
        if (transaction.isAwaitingManualReview()) {
            return Offer.DisplayOfferStatus.newOrderManualReview;
        }
        if (transaction.isFullPriceOrder()) {
            return Offer.DisplayOfferStatus.newOrder;
        }
        if (transaction.isBuyerOfferWithReserve()) {
            return Offer.DisplayOfferStatus.newBuyerOfferWithReserve;
        }
        switch (this.get('status')) {
            case Offer.STATUS_SUBMITTED:
                // countered offers
                if (transaction.isMostRecentlyDealerCountered()) {
                    return Offer.DisplayOfferStatus.dealerCountered;
                } else if (transaction.isMostRecentlyBuyerCountered()) {
                    return Offer.DisplayOfferStatus.buyerCountered;
                // new offers
                } else if (this.isBuyerInitiatedOffer()) {
                    return Offer.DisplayOfferStatus.newBuyerOfferWithoutReserve;
                } else {
                    return Offer.DisplayOfferStatus.newDealerOffer;
                }
            case Offer.STATUS_ACCEPTED:
                if (transaction.hasAction(Action.CODE_BUYER_CHECKOUT_ACCEPTED_BUYER_OFFER)) {
                    return Offer.DisplayOfferStatus.dealerAccepted;
                } else {
                    return Offer.DisplayOfferStatus.newOrder;
                }
            case Offer.STATUS_REQUESTED:
                return Offer.DisplayOfferStatus.requestedOffer;
        }
    },
    isUserComesFromAmpPage() {
        const params = qs.parse(document.location.search.substr(1));
        return _.has(params, 'userComesFromAmp') && params.userComesFromAmp === 'true';
    },
    redirectToCheckout(options = {}) {
        const { item } = options;

        if (!item) {
            throw new Error('options.item required for redirectToCheckout');
        }

        options = Object.assign({
            offerAmount: this.get('amountPerItem.amount'),
            offerCurrency: this.get('amountPerItem.currency'),
            quantity: this.get('quantity'),
            chkIncludeOffer: true
        }, options);

        if (this.isUserComesFromAmpPage()) {
            options.userComesFromAmp = true;
        }

        // we are not passing the item itself
        delete options.item;

        const params = qs.stringify(options);
        const url = '/checkout' + item.getPDPURL(false) + '?' + params;

        uri.redirect({ url });
    },
    /**
     * @deprecated since .COM version 56.
     * We don't ever want to POST to checkout any more. We should always use a GET with query params.
     * Use offer.redirectToCheckout instead.
     */
    postToCheckout: function (options) {
        console.warn("Calling deprecated function! Use redirectToCheckout instead.");
        this.redirectToCheckout(options);
    },
    idAttribute: "id",
    /**
     * @memberof bunsen.Offer
     * @returns {string}
     */
    url : function () {
        return endpoints.offer(this.get(this.idAttribute));
    },
    defaults : {
        amountPerItem : {},
        subTotalAmount : {},
        quantity : 1,
        notes : [],
        transaction: {}
    },
    relations: function () {
        return [
            {
                type: Backbone.One,
                key: 'item',
                relatedModel: SoaModel,
                collectionType: SoaCollection
            },
            {
                type: Backbone.One,
                key: 'transaction',
                relatedModel: Transaction,
                saveJSONFields : ['id']
            },
            {
                type: Backbone.One,
                key: 'adjustments',
                relatedModel: AdjustmentList,
                collectionType: SoaCollection
            },
            {
                type: Backbone.Many,
                key: 'notes',
                collectionType: Notes
            },
            {
                type: Backbone.One,
                key: 'paymentAuthorization',
                relatedModel: PaymentAuthorization,
                collectionType: SoaCollection
            },
            {
                type: Backbone.One,
                key: 'initiatingParty',
                relatedModel: Party
            },
            {
                type: Backbone.One,
                key: 'counterParty',
                relatedModel: Party
            },
            {
                type: Backbone.One,
                key: 'amountPerItem',
                relatedModel: FinancialAmount
            },
            {
                type: Backbone.One,
                key: 'subTotalAmount',
                relatedModel: FinancialAmount
            },
            {
                type: Backbone.One,
                key: 'totalAmount',
                relatedModel: FinancialAmount
            },
            {
                type: Backbone.One,
                key: 'expirationPeriod',
                relatedModel: Period
            }
        ];
    },
    getQuantity: function () {
        return Number(this.get('quantity'));
    },
    getSellerId : function () {
        if (this.isDealerInitiatedOffer()) {
            return this.get('initiatingParty').id;
        } else {
            return this.get('counterParty').id;
        }
    },
    getInitiatingPartyRole: function () {
        return this.get('initiatingParty').getRole();
    },
    getCounterPartyRole: function () {
        return this.get('counterParty').getRole();
    },
    isBuyerInitiatedOffer: function () {
        return this.get('initiatingParty').isBuyer();
    },
    isDealerInitiatedOffer: function () {
        return this.get('initiatingParty').isSeller();
    },
    isAccepted: function () {
        return Offer.STATUS_ACCEPTED === this.get('status');
    },
    isSubmitted: function () {
        return this.get('status') === Offer.STATUS_SUBMITTED;
    },
    isExpired: function () {
        return this.get('status') === Offer.STATUS_EXPIRED;
    },
    isNewStatus: function () {
        return this.get('status') === Offer.STATUS_NEW;
    },
    isCanceled: function () {
        return this.get('status') === Offer.STATUS_CANCELED;
    },
    isRequested: function () {
        return this.get('status') === Offer.STATUS_REQUESTED;
    },
    getTaxAmount: function (currency) {
        const adjustments = this.get('adjustments');
        if (adjustments) {
            return adjustments.getMerchTaxTotal(currency);
        }
        return 0;
    },
    hasTax: function () {
        return this.getTaxAmount(FinancialAmount.CURRENCY_USD) > 0;
    },
    /**
     * Creates a new empty counter offer from this offer,
     * (same item, roles reversed, amounts emptied)
     */
    newCounterOffer: function () {
        const offer = new Offer({
            transaction: {
                id: this.get('transaction.id')
            },
            quantity: this.get('quantity'),
            counterParty: {
                id: this.get('initiatingParty.id'),
                role: this.getInitiatingPartyRole()
            },
            initiatingParty: {
                id: this.get('counterParty.id'),
                role: this.getCounterPartyRole()
            },
            amountPerItem: this.get('amountPerItem').toJSON(),
            subTotalAmount: {
                amount: this.get('amountPerItem.amount') * this.get('quantity'),
                currency: this.get('amountPerItem.currency')
            }
        });
        return offer;
    },
    newAmendedOffer: function () {
        const offer = this.clone();
        _.each(['id', 'status', 'createdDate', 'expirationDate', 'expiredDate', 'modifiedDate'], offer.unset.bind(offer));
        return offer;
    },
    accept: function (passedOptions) {
        return this.transition(Offer.STATUS_ACCEPTED, passedOptions);
    },
    counter: function (counterOffer, passedOptions) {
        const options = passedOptions || {};
        _.extend(options, {
            queries: counterOffer._getCounterOfferQueryParams()
        });
        return this.transition(Offer.STATUS_COUNTERED, options);
    },
    _getCounterOfferQueryParams: function () {
        return {
            counterOfferAmount: this.get('amountPerItem.amount'),
            counterOfferCurrency: this.get('amountPerItem.currency')
        };
    },
    _actOnOffer: function (role, counterOffer, passedOptions) {
        let options;
        let dynaOptions;
        const clump = new Clump();
        let saves;

        if (!!passedOptions && passedOptions.noteContent) {
            dynaOptions = {
                "open": "___",
                "close": "___",
                "params": {
                    counterOfferId: {
                        clumpElement: "counterOffer",
                        expression: "$.result.counterOfferId"
                    }
                }
            };
        }

        // If no counter offer, accept this offer
        if (!counterOffer) {
            return this.accept();
        }

        options = _.extend({}, passedOptions || {}, {
            counterOffer: counterOffer,
            noteRole: role
        });
        saves = this.clumpCounterOfferNote(clump, options);
        clump.run({dynaOptions: dynaOptions});
        return $.when.apply($, saves);
    },
    /**
     * Accepts or counters an offer, will add note to counter
     * @param [counterOffer] - will accept the offer if this is null
     * @param [passedOptions]
     * @returns {*}
     */
    dealerActOnOffer: function (counterOffer, passedOptions) {
        return this._actOnOffer(Party.ROLE_SELLER, counterOffer, passedOptions);
    },
    buyerActOnOffer: function (counterOffer, passedOptions) {
        return this._actOnOffer(Party.ROLE_BUYER, counterOffer, passedOptions);
    },
    /**
     * Pass in a clump instance and it will counter the offer and create the note on it.
     * Add more stuff with the same clump and run it later.
     * @param clump
     * @param passedOptions
     * @returns {Array}
     */
    clumpCounterOfferNote: function (clump, passedOptions) {
        let note;
        const saves = [];
        const options = passedOptions || {};
        saves.push(this.counter(options.counterOffer, {
            clump: clump,
            clumpName: 'counterOffer'
        }));

        if (options.noteContent) {
            note = options.counterOffer.newBuyerSellerNote({
                content: options.noteContent,
                role: options.noteRole
            });
            note.setAnchorId('OFFER', "___counterOfferId___");
            saves.push(note.save(null, {clump: clump}));
        }
        return saves;
    },
    newBuyerSellerNote: function (passedOptions) {
        const options = _.defaults(passedOptions || {}, {
            type: Note.TYPE_BUYER_SELLER
        });
        return this.newNote(options);
    },
    newNote: function (passedOptions) {
        const options = _.defaults(passedOptions, {
            anchors: [
                {
                    sourceId : this.get('transaction').id,
                    sourceType : Anchor.TYPE_TRANSACTION
                },
                {
                    sourceId: this.getSellerId(),
                    sourceType : Anchor.TYPE_SELLER
                },
                {
                    sourceId: this.id,
                    sourceType: Anchor.TYPE_OFFER
                }
            ]
        });
        return this.get('notes').newNote(options);
    },
    addNewNote : function (noteOptions, syncOptions) {
        const note = this.newNote(noteOptions);
        this.get('notes').add(note);
        return note.save(null, syncOptions);
    },
    getAmountPerItem: function (currency) {
        return this._getFinancialAmount('amountPerItem', currency);
    },
    getAcceptedDate: function () {
        const unixDate = this.get('acceptedDate');
        const acceptedDate = new Date(unixDate);
        return ((acceptedDate.getMonth() + 1) + '-' + acceptedDate.getFullYear());
    }
}, transitionMixin, financialAmountMixin);



// WEBPACK FOOTER //
// ./~/bunsen/models/ecomm/Offer.es.js